// import iconcus from "../assets/images/kirkos_logo.svg";
import { useState, useRef, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Eye, EyeSlash } from "react-bootstrap-icons";

import "./MerchantKirkoslogin.css";
import {
  // car_home,
  // car_sign_in,
  // kirkos_logo,
  // car_sign_up,
  // icon_black,
  // icon_normal,
  // kirkos_merchant_white_car,
  // kirkos_merchant_yellow_car,
  // kirkos_merchant_red_car,
  // kirkos_merchant_logo,
  kirkos_merchant_profile,
} from "../../../assets/images";
import {
  // CustomCheckBox,
  CustomInput,
  ErrorModal,
  CustomRadio,
  MerchantOnboardLeftSide,
  // Progressbar,
} from "../../../components";
import {
  // FieldValues,
  useForm,
} from "react-hook-form";
import rules from "../../../rules";
import { useQueryClient, useQuery, useMutation } from "@tanstack/react-query";
import axiosInstance from "../../../services/axios.instance";
import { API_URL } from "../../../services/apiConfig";
import {
  LoginData,
  UserData,
  // VerifyOtp
} from "../../../types";
import { Navigate, useNavigate } from "react-router-dom";
import "../../../Pages/Customer/signin/styles.css";
import RegistrationModal from "../../../components/RegistrationModal";
// import { getTotp } from "../../../utils/totpUtil";
// import MerchantProgressbar from "../../../components/MerchantProgressbar";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../../../Redux/Auth/authSlice";
import { SUCCESS_MESSAGES, ERROR_MESSAGES } from "../../../utils/messages";

const LoginKirkos = () => {
  const usernameRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [showPassword, setShowPassword] = useState(false);
  const [userType, setUserType] = useState<string>("MERCHANT");
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false); // State to manage modal visibility
  const [errorMessage, setErrorMessage] = useState(""); // State to store error message
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm({ mode: "onChange" });

  let access_token: string = "";
  let refresh_token: string = "";
  const decodeToken = (token: any) => {
    return JSON.parse(atob(token.split(".")[1]));
  };

  const handleUserTypeChange = (value: string) => () => {
    setUserType(value);
  };
  const options = [
    { label: "Merchant", value: "MERCHANT" },
    { label: "Operation", value: "MERCHANT_OPERATION" },
  ];

  const handleLogin = useMutation({
    mutationFn: (userData: LoginData) => {
      setIsButtonLoading(true);
      return axiosInstance.post(API_URL.LOGIN, userData);
    },

    onSuccess: (successResponse: any) => {
      console.log("successResponse", successResponse);
      access_token = successResponse?.data?.access_token;
      refresh_token = successResponse?.data?.refresh_token;
      const decodedToken: any = decodeToken(access_token);

      // Get access and lastLevel values
      const access = decodedToken?.permission;
      let lastLevel = successResponse?.data?.last_level;
      setIsButtonLoading(false);

      // Handle MERCHANT_OPERATION specific logic
      // if (userType === "MERCHANT_OPERATION") {
      //   lastLevel = "1"; // Override lastLevel for MERCHANT_OPERATION

      //   if (access === "full-access" && lastLevel === "1") {
      //     localStorage.setItem("access_token", access_token);
      //     localStorage.setItem("refresh_token", refresh_token);
      //     saveTokenToLocalStorage();
      //     dispatch(loginSuccess());
      //     navigate("/merchant/operationsHome"); // Navigate to operations home
      //     return;
      //   }
      // }

      // Handle MERCHANT userType logic
      if (access === "partial-access") {
        localStorage.setItem("access_token", access_token);
        localStorage.setItem("refresh_token", refresh_token);
      }

      if (access === "partial-access" && lastLevel === "1") {
        navigate("/merchant/signup/businesspage");
      } else if (access === "partial-access" && lastLevel === "2") {
        navigate("/merchant/signup/licensedetails");
      } else if (access === "partial-access" && lastLevel === "3") {
        navigate("/merchant/signup/kycdetails");
      } else if (access === "partial-access" && lastLevel === "999") {
        setShowSuccessModal(true);
      } else if (access === "full-access") {
        localStorage.setItem("access_token", access_token);
        localStorage.setItem("refresh_token", refresh_token);
        saveTokenToLocalStorage();
        dispatch(loginSuccess());
        navigate("/merchant/home");
      } else {
        // Show error if access is denied
        setShowErrorModal(true);
        setErrorMessage(ERROR_MESSAGES.ACCESS_DENIED);
      }
    },
    onError: (error: any) => {
      if (error?.data?.message) {
        setIsButtonLoading(false);
        setErrorMessage(error?.data?.message);
        setShowErrorModal(true);
      }
    },
  });

  const saveTokenToLocalStorage = () => {
    if (isChecked && access_token !== null && refresh_token !== null) {
      localStorage.setItem("access_token", access_token);
      localStorage.setItem("refresh_token", refresh_token);
    }
  };

  const [isChecked, setChecked] = useState(false);

  const handleCheckBoxChange = () => {
    setChecked(!isChecked);
    if (isChecked) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
    } else {
      saveTokenToLocalStorage();
    }
  };

  const combinedValidationRule = {
    validate: (value: any) => {
      const isValidEmail =
        /^(([^<>()[\]\\.+,;:\s@"']+(\.[^<>()[\]\\.,+;:\s@"']+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          value
        );
      const isValidPhoneNumber = /^5\d{8}$/.test(value);

      if (!isValidEmail && !isValidPhoneNumber) {
        return "Invalid email address or phone number";
      }
      return true;
    },
  };

  const onHandleSubmit = () => {
    const userData: LoginData = {
      username: email,
      password: password,
      userType: userType, // Set based on selected radio button
    };

    handleLogin.mutate(userData);
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="outer-container">
      <div className="container-fluid bg-black custom-container">
        {/* Main content row with two columns */}
        <div className="row onboard-garage-main">
          {/* Left side with yellow color */}
          <div className="col-md-6 custom-yellow-bg ">
            {/* Logo in the top-left corner of the yellow part */}
            <MerchantOnboardLeftSide />
          </div>
          {/* Right side with black color */}
          <div className="col-md-6 merchant_login_right text-light background-right-side-onboard ">
            <div className=" ps-3 pt-5 pe-2 text-start">
              <div className=" d-flex  pt-5 ">
                <img
                  src={kirkos_merchant_profile}
                  className="icon-img img-fluid"
                  alt="Icon"
                />
                <p className=" merchant_login_text text-light ps-3 pt-3">
                  Merchant Login
                </p>
              </div>
              <div className="d-flex">
                <div className="merchant_newkirkos_text pt-1">
                  New To KIRKOS?
                </div>
                <a
                  href="/merchant/signup"
                  className="merchant_login_signup_text ps-2 "
                >
                  Sign up
                </a>
                <a
                  href="/"
                  style={{
                    color: "#f4b652",
                    textDecoration: "underline",
                    marginLeft: "4%",
                    fontFamily: "Poppins, sans-serif",
                    fontStyle: "initial",
                    display: "inline",
                  }}
                >
                  Home{" "}
                </a>
              </div>
              <div className="d-flex align-items-center pt-4">
                {options.map((option) => (
                  <div className="px-2">
                    <CustomRadio
                      key={option.value}
                      label={option.label}
                      checked={userType === option.value}
                      onChange={handleUserTypeChange(option.value)}
                    />
                  </div>
                ))}
              </div>

              <div className="merchant_login_headingStyle1 pt-1">
                Username
                <span className="merchanttopstar">*</span>
              </div>

              <div
                className="inputContainerStyle pt-3"
                onClick={() => usernameRef.current?.focus()}
              >
                <CustomInput
                  inputName="email"
                  inputType="email"
                  className="merchant_login_input_field"
                  placeholder="email-id or phone number"
                  editable={true}
                  onInputChange={(value: string) => setEmail(value)}
                  control={control}
                  rules={combinedValidationRule}
                  inputRef={usernameRef}
                />
              </div>
              <div className="merchant_login_headingStyle3 pt-4">
                Password<span className="merchanttopstar">*</span>
              </div>
              <div
                className="d-flex pt-3"
                onClick={() => passwordRef.current?.focus()}
              >
                <CustomInput
                  inputName="password"
                  inputType={showPassword ? "text" : "password"}
                  className="merchant_login_input_field"
                  placeholder="xxxxxx"
                  editable={true}
                  onInputChange={(value: string) => setPassword(value)}
                  control={control}
                  rules={rules.AuthRules.password}
                  inputRef={passwordRef}
                />
                <span
                  className="fs-5 password_eye"
                  onClick={(e) => {
                    e.stopPropagation();
                    togglePasswordVisibility();
                  }}
                >
                  {showPassword ? <EyeSlash /> : <Eye />}
                </span>
              </div>
              {/* <div className="d-flex pt-5 "> */}
              {/* <CustomCheckBox
                  isChecked={isChecked}
                  onChange={handleCheckBoxChange}
                />

                <span
                  className="merchant_login_rememberme_text flex-nowrap d-flex"
                  style={{ textWrap: "nowrap" }}
                >
                  Remember me
                </span> */}

              {/* <span
                  className="flex-nowrap d-flex text-end "
                  style={{ width: "100%" }}
                >
                  <a
                    href="/merchant/forgotpassword"
                    className="merchant_forgot_link"
                    style={{ textWrap: "nowrap", width: "100%" }}
                  >
                    Forgot Password?
                  </a>
                </span>
              </div> */}
              <div className="col-12 text-end pt-5">
                <a
                  href="/merchant/forgotpassword"
                  className="merchant_forgot_link"
                >
                  Forgot Password?
                </a>
              </div>
              <button
                className="btn all_button_style text-black mb-5 btn "
                onClick={handleSubmit(onHandleSubmit)}
                disabled={isButtonLoading || !isValid}
              >
                SIGN IN
              </button>
            </div>
          </div>
          <RegistrationModal
            isOpen={showSuccessModal}
            onClose={() => setShowSuccessModal(false)}
            onNav={() => {
              navigate("/");
            }}
            message={SUCCESS_MESSAGES.WAITING_FOR_APPROVAL}
          />
          <ErrorModal
            isOpen={showErrorModal}
            //  onClose={onCloseErrorModal}
            onClose={() => setShowErrorModal(false)}
            message={ERROR_MESSAGES.INVALID_CREDENTIALS}
          />
        </div>
      </div>
    </div>
  );
};

export default LoginKirkos;
